module.exports = "/_next/static/images/num-3-3b2f895c.png";